import { ContentContainer } from "@/components/ContentContainer";
import PageHead from "@/components/PageHead";
import TopOfGenre from "@/components/playlist/TopOfGenre";
import TopOfRegion from "@/components/playlist/TopOfRegion";
import { Divider, Grid, Typography } from "@mui/material";
import { useState } from "react";
import theme from "../../styles/theme";

export default function PlaylistIndex({ page }) {
  const [activePlaylist, setActivePlaylist] = useState(null);

  return (
    <>
      <PageHead page={page} />

      <ContentContainer
        headline={page.headline}
        image={page?.hero_image?.formats?.large?.url}
      >
        <Grid
          container
          sx={{
            mb: 5,
            [theme.breakpoints.up("sm")]: {
              mb: 0,
            },
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h4" sx={{ mb: 1 }}>
              {page.headline_genres}
            </Typography>
          </Grid>
          <TopOfGenre active={activePlaylist} onPlay={setActivePlaylist} />

          <Grid item xs={12}>
            <Divider
              sx={{
                mt: 9,
                mb: 4,
                [theme.breakpoints.up("sm")]: {
                  mt: 7,
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h4" sx={{ mb: 1 }}>
              {page.headline_regions}
            </Typography>
          </Grid>
          <TopOfRegion active={activePlaylist} onPlay={setActivePlaylist} />
        </Grid>
      </ContentContainer>
    </>
  );
}

export const getStaticProps = async () => {
  const pageResponse = await fetch(
    `${
      process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"
    }/page-music-explore`,
  );
  const page = await pageResponse.json();

  return {
    props: {
      page,
    },
    revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT),
  };
};
